
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer02 as ObiTransformer02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-02.js';
 
 
 

 
 export const ObiTransformer02 = createComponent({
   react: React,
   tagName: 'obi-transformer-02',
   elementClass: ObiTransformer02Element,
   events: {
     
   }
  });
 
 